export const regionList = [
  {
    value: 'NCR',
    label: 'NCR',
  },

  {
    value: 'Region I',
    label: 'Region I',
  },

  {
    value: 'Region II',
    label: 'Region II',
  },

  {
    value: 'Region III',
    label: 'Region III',
  },

  {
    value: 'Region IV',
    label: 'Region IV',
  },

  {
    value: 'Region V',
    label: 'Region V',
  },

  {
    value: 'Region VI',
    label: 'Region VI',
  },

  {
    value: 'Region VII',
    label: 'Region VII',
  },

  {
    value: 'Region VIII',
    label: 'Region VIII',
  },

  {
    value: 'Region IX',
    label: 'Region IX',
  },

  {
    value: 'Region X',
    label: 'Region X',
  },

  {
    value: 'Region XI',
    label: 'Region XI',
  },

  {
    value: 'Region XII',
    label: 'Region XII',
  },
]
